import type { AgenticLogicView } from "../surface/ruleViewParams";

/**
 * What the takeover remembers between views: which view opened it, and the
 * rule it has already bound.
 */
export interface TakeoverBindingState {
  enteredAs: "new" | "rule" | null;
  boundRuleId: string | null;
}

export const INITIAL_TAKEOVER_BINDING: TakeoverBindingState = {
  enteredAs: null,
  boundRuleId: null,
};

/**
 * Whether arriving at `view` should bind a rule to the host's placement.
 *
 * A build hands the author from the creation view to the rule it produced, and
 * THAT transition is the binding — not the mere presence of a rule id. Opening
 * straight onto a rule is the Edit affordance, which changes no binding. The
 * memory is cleared when the takeover closes, so editing a rule after creating
 * one cannot re-bind.
 */
export const nextTakeoverBinding = (
  previous: TakeoverBindingState,
  view: AgenticLogicView
): { state: TakeoverBindingState; bind: string | null } => {
  if (view.kind === "list") {
    return { state: INITIAL_TAKEOVER_BINDING, bind: null };
  }

  const enteredAs = previous.enteredAs ?? view.kind;
  const state = { ...previous, enteredAs };

  if (enteredAs !== "new" || view.kind !== "rule") {
    return { state, bind: null };
  }
  if (previous.boundRuleId === view.ruleId) {
    return { state, bind: null };
  }

  return { state: { ...state, boundRuleId: view.ruleId }, bind: view.ruleId };
};
